import { laptopMediumMax, mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import { Container as Button } from '@propertypal/web-ui/src/buttons/Button.style';
import { Container as SelectInput } from '@propertypal/web-ui/src/inputs/SelectInput.style';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';

export const Container = styled.div`
  ${Button} {
    max-width: 300px;
    margin: -30px auto 30px;

    @media (${laptopMediumMax}) {
      margin: -30px auto 15px;
    }
  }
`;

export const Header = styled.div<{ $hasPinned?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  gap: 15px;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto -${(props) => (props.$hasPinned ? 0 : 30)}px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  ${SelectInput} {
    min-width: 200px;
  }

  @media (${mobileXLargeMax}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PinnedPropertyContainer = styled.div`
  max-width: ${MAX_WIDTH}px;
  margin: 30px auto -30px;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;
